import { excludeForwardProps } from '@gasbi/shared/common/utils/excludeForwardProps';

import { styled } from '@mui/joy';
import Chip from '@mui/joy/Chip';

import { commonBaseButtonStyles } from '@components/BaseStyledComponents/common';

export const BaseChip = styled(Chip, {
  shouldForwardProp: excludeForwardProps('isPrimary'),
})<{ isPrimary?: boolean }>(({ theme, isPrimary }) => ({
  ...commonBaseButtonStyles(theme),
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[400]
    : isPrimary
      ? theme.palette.primary[500]
      : theme.palette.neutral[50],
  span: {
    color: theme.palette.isDarkMode
      ? theme.palette.neutral[900]
      : theme.palette.neutral[50],
  },
  '&:hover': {
    backgroundColor: 'none',
  },
}));
